// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3063) return "static/chunks/3063-c2f66440ef786064.js";
	if (chunkId === 1978) return "static/chunks/1978-4dae87d0635cba97.js";
	if (chunkId === 6711) return "static/chunks/8e1d74a4-af173cf7454a7802.js";
	if (chunkId === 3696) return "static/chunks/3696-edb3a83076dbec5b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1264":"0db4e1dd31544f32","3028":"eb02a46dd530aff6","4279":"0fe8d1c0b382daa0","4519":"529faf5b58a68640","6175":"39fd306a37cfb5ed","6601":"8a0d15ccd77c1067","6913":"b0c4cfe25458a994","8912":"2fdfcb3701d0a50c","9328":"25ce5a20e7d8245a","9391":"75361344b0a4d912","9985":"84dc15412e3c81ce"}[chunkId] + ".js";
};